import { ArticlePage2 } from './ArticlePage2.js';

export class ArticlePageNWFL8 extends ArticlePage2 {
    constructor(containerId) {
        super(containerId, {
            headline: "Super Six Preview",
            author: "footballgirl",
            date: "January 3, 2024",
            imageGradient: "linear-gradient(135deg, #008751 0%, #ffffff 50%, #008751 100%)",
            content: `<p>The race for the Super Six is heating up. We predict which teams will make the cut for the championship playoffs.</p>`,
            navIndices: { prev: 'nwfl-7', next: 'nwfl-9' }
        });
    }

    init() {
        console.log('ArticlePageNWFL8 initialized');
        super.init();
    }

    render() {
        super.render();
        
        const backBtn = this.element.querySelector('#articleBackBtn');
        if (backBtn) {
            backBtn.innerHTML = `
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width: 16px; height: 16px; margin-right: 6px;">
                    <line x1="19" y1="12" x2="5" y2="12"></line>
                    <polyline points="12 19 5 12 12 5"></polyline>
                </svg>
                Back to NWFL
            
<div style="margin:24px auto;max-width:720px;text-align:center;"><script async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-7705230222200385" crossorigin="anonymous"></script><ins class="adsbygoogle" style="display:block;text-align:center;" data-ad-layout="in-article" data-ad-format="fluid" data-ad-client="ca-pub-7705230222200385" data-ad-slot="1708603458"></ins><script>(adsbygoogle = window.adsbygoogle || []).push({});</script></div>
`;
            
            const newBackBtn = backBtn.cloneNode(true);
            backBtn.parentNode.replaceChild(newBackBtn, backBtn);
            
            newBackBtn.addEventListener('click', (e) => {
                e.preventDefault();
                const event = new CustomEvent('navigateHome', { bubbles: true, detail: { anchor: 'nwfl' } });
                this.element.dispatchEvent(event);
            });
        }

        const leagueLogo = this.element.querySelector('.hero-util-btn img');
        if (leagueLogo) {
            leagueLogo.src = '/images/league_nwfl.png';
            leagueLogo.alt = 'NWFL';
        }
    }
}